"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var ToggleWrapper = /** @class */ (function (_super) {
    __extends(ToggleWrapper, _super);
    function ToggleWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToggleWrapper.prototype.findLabel = function () {
        return this.find('.awsui-toggle');
    };
    ToggleWrapper.prototype.findNativeInput = function () {
        return this.find('.awsui-toggle-native-input');
    };
    ToggleWrapper.prototype.findDescription = function () {
        return this.find('.awsui-toggle-description');
    };
    return ToggleWrapper;
}(dom_1.ComponentWrapper));
exports.default = ToggleWrapper;
//# sourceMappingURL=awsui-toggle.js.map